import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';

import App from './app/App';
import createStore from './services/store';

const store = createStore()

render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById('root')
);
